import { useState } from 'react';
export var useModalHelper = function () {
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    function openModal() {
        setShowModal(true);
    }
    function closeModal() {
        setShowModal(false);
    }
    return { showModal: showModal, openModal: openModal, closeModal: closeModal };
};
//# sourceMappingURL=useModalHelper.js.map